// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__ZGqaW","additionalInfo":"AgreementModal_additionalInfo__1ie_1"};